<template>
    <modalComponent :show="show">
        <div class="modal-content ">
            <div class="modal-header">
                <h6 class="modal-title m-0" id="exampleModalDefaultLabel">Attachments</h6>
                <button type="button" class="close" v-on:click="close()"><span
                        aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
               
                
                <div class="form-group">
                    <label>Description ( Optional )</label>
                    <textarea class="form-control" v-model="attachement.description"></textarea>
                </div>
                <div class="form-group">
                    <label>Upload File</label>
                    <input type="file" ref="imgupload" class="form-control" @change="uploadImage('onClick')"
                    id="file-input">
                </div>
                <div class="submit-section text-center">
                    <button type="submit" class="btn btn-primary submit-btn" v-bind:disabled="v$.attachement.$invalid" @click="Save()">Submit</button>
                    <button type="button" class="btn btn-secondary submit-btn" v-on:click="close()">Cancel</button>
                </div>
            </div>

            <loading v-model:active="loading" :can-cancel="false" :is-full-page="true"></loading>
        </div>
    </modalComponent>
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
export default {
    components: {
        Loading
    },
    props: ['show', 'id'],
    setup() {
        return { v$: useVuelidate() }
    },
    data: function () {
        return {
            loading: false,
            image: '../../images/Placeholder.svg',
            data: [],
            url: '',
            filePath: null,

            attachement: {
                id: '00000000-0000-0000-0000-000000000000',
                userId: '',
                name: '',
                description: '',
                filePath: '',
            }
        }
    },
    validations() {
        return {
            attachement: {
                userId: {
                    required: required
                },
                filePath: {
                    required: required
                }
            }
        }
    },
    methods: {
        close: function () {
            this.$emit('close');
        },

        uploadImage() {
            var root = this;
            var file = this.$refs.imgupload.files;

            this.filePath = null;
            var fileData = new FormData();
            this.image = URL.createObjectURL(this.$refs.imgupload.files[0]);
            // convert file into FormData object
            for (var k = 0; k < file.length; k++) {
                fileData.append("files", file[k]);
            }
            root.attachement.name = file[0].name;

            this.$https.post('/Home/UploadFilesAsync', fileData)
                .then(function (response) {
                    if (response.data != null) {
                        root.attachement.filePath = response.data;
                    }
                });
        },

        Save: function () {
            var root = this;
            this.loading = true;

            var token = '';
            if (root.$session.exists()) {
                token = localStorage.getItem('token');
            }

            if (this.id != '' && this.id != null && this.id != undefined) {
                this.attachement.userId = this.id;
            }
            else {
                this.attachement.userId = localStorage.getItem('UserID');

            }

            root.$https.post('/Setup/SaveAttachment', this.attachement, { headers: { "Authorization": `Bearer ${token}` } })
                .then(function (response) {

                    if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {
                        root.loading = false;
                        root.$swal({
                            title: 'Added',
                            text: 'Data has been added sucessfully.',
                            type: 'success',
                            icon: 'success',
                            confirmButtonClass: "btn btn-success",
                            buttonsStyling: false
                        }).then(function (result) {
                            if (result) {
                                //root.close();
                                root.$router.go();
                            }
                        });
                    }
                    else {
                        root.$swal({
                            title: 'Error',
                            text: response.data.isAddUpdate,
                            type: 'error',
                            icon: 'error',
                            confirmButtonClass: "btn btn-danger",
                            buttonsStyling: false
                        });
                        root.loading = false;
                    }
                }).catch(error => {
                    console.log(error)
                    root.$swal.fire(
                        {
                            icon: 'error',
                            type: 'error',
                            title: 'Error',
                            text: 'Something went wrong.',
                            showConfirmButton: false,
                            timer: 5000,
                            timerProgressBar: true,
                        });
                    root.loading = false;
                })
                .finally(() => root.loading = false);
        },
    },
    mounted: function () {
        this.attachement.userId = localStorage.getItem('UserID');
    },
}
</script>